var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navi"},[_c('div',{staticClass:"logo"}),_c('ul',_vm._l((_vm.links),function(link){return _c('li',{key:link,staticClass:"link",class:_vm.linkClass(link),on:{"click":function($event){return _vm.handleClick(link)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }